<template>
  <div class="body">
    <div class="detay">
      <div class="sayfahead tek">
        <h1>JetUsta Teknik

          <el-button-group class="float-right YeniBtn">
            <el-select @change="DurumDegistir" class="selectbtn" size="mini" v-model="Durum" filterable>
              <el-option
                v-for="item in Durumlar"
                :key="item.id"
                :label="item.Adi"
                :value="item.id">
              </el-option>
            </el-select>
            <el-button type="success" size="mini" @click="YeniTalepModal=true">
              Yeni Talep
            </el-button>
            <el-button type="info" size="mini" @click="Yazdir('Liste')">
              Liste Yazdır
            </el-button>
            <el-button type="primary" size="mini" @click="Yazdir('Form')">
              Form Yazdır
            </el-button>
          </el-button-group>
        </h1>
      </div>

      <div class="icerik yazdirma" style="height: calc(100vh + 10px) !important;">
        <div class="SpotlightKutu" style="z-index: 1">
          <div class="input">
            <el-input
              :disabled="lo"
              placeholder="Muhatap yazarak aratınız"
              v-model="search">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
        <el-table
          v-if="Liste"
          :data="Liste.filter(data => !search || data.Muhatap.toLowerCase().includes(search.toLowerCase()) || data.Adres.toLowerCase().includes(search.toLowerCase()))"
          :height="Height"
          class="yazdirma"
          @current-change="TableSecim">
          <el-table-column
            label="Talep Tarihi"
            prop="tarih"
            width="100">
          </el-table-column>
          <el-table-column
            label="Randevu Tarihi"
            prop="Randevu"
            width="200">
          </el-table-column>
          <el-table-column
            label="Hizmet"
            prop="Hizmet"
            width="300">
          </el-table-column>
          <el-table-column
            label="Muhatap"
            prop="Muhatap"
            width="300">
          </el-table-column>
          <el-table-column
            label="Açıklama"
            prop="Aciklama">
          </el-table-column>
          <el-table-column
            label="Durum"
            prop="DurumText"
            width="120">
          </el-table-column>
        </el-table>

      </div>


      <Yukleniyor :data="lo"></Yukleniyor>
      <juTalepDetay :data="Secili" v-if="Secili" @Kapat="DurumDegistir(Durum)"></juTalepDetay>
      <juYeniTalep v-if="YeniTalepModal" @Kapat="DurumDegistir(Durum)"></juYeniTalep>
      <JuTalepYazdir v-if="YazdirTur==='Liste'" :data="Liste"></JuTalepYazdir>
      <JuTalepForm v-if="YazdirTur==='Form'" :data="Liste"></JuTalepForm>
    </div>
  </div>

</template>

<script>
import Yukleniyor from "../../../components/Doc/Yukleniyor";
import JuTalepDetay from "./juTalepDetay";
import JuYeniTalep from "./juYeniTalep";
import JuTalepYazdir from "./juTalepYazdir";
import JuTalepForm from "./juTalepForm";

export default {
  components: {JuTalepYazdir, JuYeniTalep, JuTalepDetay, Yukleniyor, JuTalepForm},
  data() {
    return {
      Height: window.innerHeight - 100,
      Liste: null,
      YazdirTur: 'Form',
      search: '',
      lo: false,
      YeniTalepModal: false,
      Secili: null,
      Durum: 1,
      Durumlar: [
        {id: 1, Adi: 'Keşif Bekliyor'},
        {id: 2, Adi: 'Ödeme Bekliyor'},
        {id: 3, Adi: 'İşlem Yapılıyor'},
        {id: 4, Adi: 'Teslim Edildi'},
        {id: 5, Adi: 'İptal Edildi'},
      ],
    }
  },
  methods: {

    TableSecim(val) {
      this.Secili = val;
    },
    Yazdir(Tur) {
      this.YazdirTur = Tur
      setTimeout(() => {
        window.print();
      }, 100);
    },
    DurumDegistir(Tur) {
      this.Secili = null
      this.Durum = Tur
      this.DonemModalDurum = false
      this.YeniTalepModal = false
      this.lo = true
      this.$store.dispatch("Get", {path: '_ju/siparis/' + Tur})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
          }
        });

    }
  },
  created() {
    this.DurumDegistir(this.Durum)

  }
}
</script>

<style scoped>
.selectbtn {
  width: 180px !important;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/JetUsta/Comp/juTalepler.vue